import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAccessibility } from '../contexts/AccessibilityContext';
import AacButton from '../components/aac/AacButton';

/**
 * Catch-all for any unmatched route. Previously there was no `path="*"`
 * route at all, so an unknown URL (a typo, an old bookmark, a stray link
 * like /contact which was never a real route) rendered only the header
 * and footer shell — no heading, no content, no way back — which is both
 * a broken experience and an accessibility dead end for anyone landing
 * there via keyboard/switch-scanning navigation.
 */
const NotFound = () => {
  const { announce, focusFirstHeading } = useAccessibility();
  const navigate = useNavigate();

  useEffect(() => {
    focusFirstHeading();
    announce('Page not found');
  }, [announce, focusFirstHeading]);

  return (
    <div className="auth-page">
      <h1>Page Not Found</h1>
      <p className="auth-page__intro">
        Sorry, we couldn&apos;t find that page. It may have been moved, or the
        link might be out of date.
      </p>

      <div className="auth-page__actions">
        <AacButton onClick={() => navigate('/')} shortcut={1}>
          🏠 Go to Home
        </AacButton>
      </div>

      <div className="auth-page__links">
        <Link to="/programme">Browse the Programme</Link>
        <Link to="/qa">Ask a question</Link>
      </div>
    </div>
  );
};

export default NotFound;
